import { REPORT } from '@consts/reports';
import { hasResellerViewPermission } from '@utils/helper';
import { useSelector } from 'react-redux';
import { LocationsCutLastMonthNotThisMonth } from '@components/reports/issues/LocationsCutLastMonthNotThisMonth';
import { ResellersCutLastMonthNotThisMonth } from '@components/reports/issues/ResellersCutLastMonthNotThisMonth';
import { LocationsNoCutsLastWeek } from '@components/reports/issues/LocationsNoCutsLastWeek';
import { LocationsOverWarrantyRate } from '@components/reports/issues/LocationsOverWarrantyRate';
import { BaseReportPage } from './bases/BaseReportPage';
import { LocationsNoCutsByMaterial } from '@components/reports/issues/LocationsNoCutsByMaterial';
import { Materials } from '@consts/materials';
import { ReportTips } from '@components/ReportTips';
import { useReportLoad } from '@hooks/useReportLoad';

import type { RootState } from '@features/redux/store';

interface IssuesProps {
    showTips: boolean;
    dateRange: { startDate: string; endDate: string };
    setDateRange: (dateRange: { startDate: string; endDate: string }) => void;
}

export const Issues = ({ showTips, dateRange, setDateRange }: IssuesProps) => {
    const { IdToken } = useSelector((state: RootState) => state.auth);

    const resellerViewPermitted = hasResellerViewPermission(IdToken);
    const { data: productNames = [] } = useReportLoad({
        reportType: REPORT.PRODUCTS_PRODUCT_NAMES,
        params: {},
    });

    return (
        <BaseReportPage dateRange={dateRange} setDateRange={setDateRange} title={'MO Insights Issues'}>
            {showTips && <ReportTips reportType={REPORT.ISSUES_TIPS} />}

            <LocationsCutLastMonthNotThisMonth />

            {resellerViewPermitted && <ResellersCutLastMonthNotThisMonth />}

            <LocationsNoCutsLastWeek />

            <LocationsOverWarrantyRate />

            {productNames.map(({ productName }: any) => (
                <LocationsNoCutsByMaterial key={productName} dateRange={dateRange} productName={productName} />
            ))}
        </BaseReportPage>
    );
};
